import { render, staticRenderFns } from "./texteditor.vue?vue&type=template&id=4644916c"
import script from "./texteditor.vue?vue&type=script&lang=js"
export * from "./texteditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports